export default "__VITE_ASSET__DxOhQwsH__"